"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { useState } from "react";
import { toast } from "sonner";
import { AppConfigProvider } from "@/lib/config";
import { errorMessage } from "@/lib/utils";
import { Toaster, TooltipProvider } from "@llmgateway/shared/components";
import type { AppConfig } from "@/lib/config-server";
import type { ReactNode } from "react";
export function Providers(t0) {
  const $ = _c(11);
  const {
    children,
    config
  } = t0;
  const [queryClient] = useState(_temp2);
  let t1;
  if ($[0] !== children) {
    t1 = <TooltipProvider delayDuration={200}>{children}</TooltipProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== queryClient || $[3] !== t1) {
    t2 = <QueryClientProvider client={queryClient}>{t1}</QueryClientProvider>;
    $[2] = queryClient;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Toaster richColors={true} position="bottom-right" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="admin-theme">{t2}{t3}</ThemeProvider>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== config || $[9] !== t4) {
    t5 = <AppConfigProvider config={config}>{t4}</AppConfigProvider>;
    $[8] = config;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 30000,
        retry: false
      },
      mutations: {
        onError: _temp
      }
    }
  });
}
function _temp(error) {
  toast.error(errorMessage(error));
}